import React from 'react';
import { Button, Typography } from '@mui/material';
import  Box  from '@mui/material/Box';
import { alpha, useTheme } from '@mui/system';
import { useContext } from 'react';
import { Container } from '../../components';
import { CourseCard } from '../../components';
import {Main} from '../../components/Main';
import {UserContext}  from '../../components/provider';
import { COURSES_URL } from '../../config/urls';
import Hero from './Hero';
import RoadMapCards from './RoadMapCards'

const mockup = [
  { 
    id:61,
    course_name: 'Python Tutorials',
    author: {
      name : 'Corey Schafer',
      avatar: 'https://yt3.ggpht.com/ytc/AKedOLQueRwobBmtzfRtvuQ9GJx9FdWy50w0xdybHDBQ=s176-c-k-c0x00ffffff-no-rj',
    },
    published_date: 'Sep 28, 2020',
    thumbnail_url: 'https://img.youtube.com/vi/YYXdXT2l-Gg/maxresdefault.jpg',
    url: 'https://www.youtube.com/playlist?list=PL-osiE80TeTt2d9bfVyTiXJA-UTHn6WwU',
    description_array: ['Python Tutorials. An in-depth look at the Python programming language. Learn about Python development, tips and tricks, walkthroughs, and best practices.'],
    tags: 'Corey Schafer, Python',
    is_favorite: false,
    number_of_lectures: 143,
    duration: '61:48:00',
  },
  {
    id:62,
    course_name: 'JavaScript Crash Course For Beginners',
    author:{
      name: 'Traversy Media',
      avatar: 'https://yt3.ggpht.com/ytc/AKedOLSxHOOxxa9Af8Bfb2XMop3lm4tor9bViWiC-d5aaw=s176-c-k-c0x00ffffff-no-rj',
    },
    thumbnail_url: 'https://img.youtube.com/vi/hdI2bqOjy3c/maxresdefault.jpg',
    url: 'https://www.youtube.com/watch?v=hdI2bqOjy3c',
    description_array: ['In this crash course we will go over the fundamentals of JavaScript including more modern syntax like classes, arrow functions, etc. This is the starting point on my channel for learning JS.'],
    tags: 'Traversy Media, JavaScript ',
    is_favorite: false,
    published_date: 'Mar 13, 2019',
    number_of_lectures: 1,
    duration: '01:41:00',
  },
  {
    id:63,
    course_name: 'HTML - Build a Website | Tutorial',
    author:{
      name: 'Mike Dane',
      avatar: 'https://yt3.ggpht.com/ytc/AKedOLRxS2W0dkrbJErKUdm-q-ZHp6QGMnBIIkiNKF38nw=s176-c-k-c0x00ffffff-no-rj',
    },
    published_date: 'Oct 9, 2017',
    thumbnail_url: 'https://img.youtube.com/vi/Ny1g1eQHnCI/maxresdefault.jpg',
    url: 'https://www.youtube.com/playlist?list=PLLAZ4kZ9dFpMSXUYwxDFOvyxlssug29Fu',
    description_array: ['Learn the basics of HTML and web development in this awesome free course! Giraffe Academy will teach you everything you need to know to get started building your first website!'],
    tags: 'Mike Dane, HTML',
    is_favorite: false,
    number_of_lectures: 16,
    duration: '02:03:00',
  },
  {
    id:64,
    course_name: 'Golang Tutorials',
    author:{
      name: 'Tech With Tim',
      avatar: 'https://yt3.ggpht.com/ytc/AKedOLQXx-JXf1NsSUtVHcYhx4B4MaIYE0m7I_H0GHmu-w=s176-c-k-c0x00ffffff-no-rj',
    },
    thumbnail_url: 'https://img.youtube.com/vi/75lJDVT1h0s/maxresdefault.jpg',
    url: 'https://www.youtube.com/playlist?list=PLzMcBGfZo4-mtY_SE3HuzQJzuj4VlUG0q',
    description_array: ['A tutorial series on the golang programming language. This go programming series is designed for complete beginners looking to jump into the world of go!'],
    tags: 'Tech With Tim, Golang',
    is_favorite: false,
    published_date: 'May 14, 2020',
    number_of_lectures: 22,
    duration: '04:47:00',
  },
  {
    id:65,
    course_name: 'Java tutorial for beginners',
    author:{
      name: 'Bro Code',
      avatar: 'https://yt3.ggpht.com/ytc/AKedOLQ5NOkhOOu9p0p-DIrGJUCOOtK_courxIDAPt4Jkw=s176-c-k-c0x00ffffff-no-rj',
    },
    thumbnail_url: 'https://img.youtube.com/vi/NBIUbTddde4/maxresdefault.jpg',
    url: 'https://www.youtube.com/playlist?list=PLZPZq0r_RZOMhCAyywfnYLlrjiVOkdAI1',
    description_array: ['This free java tutorial for complete beginners will help you learn the java programming language from scratch.', 'Learn Variables, Strings, Classes, Object-oriented programming & More'],
    tags: 'Bro Code, Java ',
    is_favorite: false,
    published_date: 'Nov 9, 2020',
    number_of_lectures: 100,
    duration: '11:59:00',
  },
  {
    id:66,
    course_name: 'CSS Tutorial - Zero to Hero (Complete Course)',
    author: {
      name: 'Jad Khalili',
      avatar: 'https://yt3.ggpht.com/ytc/AKedOLRyPFojwY3CXV5ks5TwPrt2VifQn-nYNfkgLvVPkw=s176-c-k-c0x00ffffff-no-rj',
    },
    publisher: 'freeCodeCamp.org',
    thumbnail_url: 'https://img.youtube.com/vi/1Rs2ND1ryYc/maxresdefault.jpg',
    url: 'https://www.youtube.com/watch?v=1Rs2ND1ryYc&t=12535s',
    description_array: ['Learn CSS in this full course for beginners. CSS, or Cascading Style Sheet, is responsible for the styling and looks of a website. ', 'In this course, we cover CSS from the ground up. You will learn everything from basic skills, such as coloring and text, to highly advanced skills, like custom animations.'],
    tags: 'Jad Khalili, freeCodeCamp, CSS',
    is_favorite: false,
    published_date: 'Oct 16, 2019',
    number_of_lectures: 1,
    duration: '06:19:00',
  },
]
const HomePage = () =>{
    const theme = useTheme();
    const {user} = useContext(UserContext);
    return (
        <Main >
          <Box position={'relative'} 
            sx={{backgroundColor: theme.palette.alternate.main,}}
          >
            <Hero />
            <Box
              component={'svg'}
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 1920 100.1"
              sx={{
                width: '100%',
                marginBottom: theme.spacing(-1),
              }}
            >
              <path
                fill={theme.palette.background.paper}
                d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
              ></path>
            </Box>
          </Box>


          <Box
          sx={{
            backgroundImage: `linear-gradient(to bottom, ${alpha(
              theme.palette.background.paper,
              0,
            )}, ${alpha(theme.palette.alternate.main, 1)} 100%)`,
            backgroundRepeat: 'repeat-x',
            position: 'relative',
          }}
          >
            <Container>
              <RoadMapCards />
            </Container>
            <Box
              component={'svg'}
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 1920 100.1"
              sx={{
                width: '100%',
                marginBottom: theme.spacing(-1),
              }}
            >
              <path
                fill={theme.palette.background.paper}
                d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
              ></path>
            </Box>
          </Box>
          
          <Container id='course-view'>
            <Box>
              <Typography
                variant={'h4'}
                gutterBottom
                align={'center'}
                sx={{ fontWeight: 700 }}
              >
                 Most Popular Tutorials
              </Typography>
              <Typography
                variant={'h6'}
                component={'p'}
                color={'text.secondary'}
                align={'center'}
              >
                Choose from hundreds of tutorials on Youtube
              </Typography>
            </Box>
            <Box 
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
              marginTop={2}
              width={0.5}
              marginX={'auto'}

            >
              <Button 
              variant="contained"
              color="primary"
              size="large"

              href={COURSES_URL}
              endIcon={
                <Box
                  component={'svg'}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  width={24}
                  height={24}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </Box>
              }>
                View All
              </Button>
              
            </Box>
        </Container>


          <Container marginTop={{xs:-4, md: -8}}>
            <CourseCard courses={mockup} maxCoursePerRow={3} authenticated={user?.email ? true : false}/>
          </Container>
        </Main>
            
            



    )
}


export default HomePage;